import { render } from "./AreaPageTab.vue?vue&type=template&id=f8bbd5e2&scoped=true"
import script from "./AreaPageTab.vue?vue&type=script&lang=js"
export * from "./AreaPageTab.vue?vue&type=script&lang=js"

import "./AreaPageTab.vue?vue&type=style&index=0&id=f8bbd5e2&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bbd5e2"]])

export default __exports__